import { InjectionToken } from '@angular/core';
import { IWebSocketEventConfig, NotificationType, QueryParamsConfig } from '@up/shared/interfaces';

export const ENV_OPTIONS = new InjectionToken<any>('ENV_OPTIONS');

export const NOTIFICATION_DISABLER = new InjectionToken<NotificationType>('NOTIFICATION_DISABLER');

export const QUERY_CONFIG_TOKEN = new InjectionToken<QueryParamsConfig>(
    'QueryParamsConfig'
);

export const WEB_SOCKET_EVENT_CONFIG = new InjectionToken<IWebSocketEventConfig[]>('WEB_SOCKET_EVENT_CONFIG');

export const CACHE_TIMEOUT = new InjectionToken<number>('CACHE_TIMEOUT');